
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.972 6.5l4.332 4.332-1.318 1.318L.336 6.5 5.986.85 7.304 2.17 2.972 6.5zm13.56 0L12.2 10.832l1.318 1.318 5.65-5.65-5.65-5.65L12.2 2.17 16.532 6.5z","fill":"#585858"}})])
          )
        }
      }
    